import { useEffect } from "react";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import { FaceLivenessDetector } from "@aws-amplify/ui-react-liveness";
import { Config } from "../interfaces/facelivelinessDetection.interface";
import "./faceLiveness.css";

function FaceLivelinessComponent({config, handleComplete, handleError, handleCancel}: {config: Config, handleComplete: () => void, handleError: (err: {state:string,error:Error}) => void, handleCancel: () => void}) {
    useEffect(() => {
        if (config.amplifyConfigJson) {
            Amplify.configure(config.amplifyConfigJson);
        }
    },[config.amplifyConfigJson]);

    const setAnalysisComplete = async() => {
        handleComplete();
    }
    return (
        <FaceLivenessDetector
        sessionId={config.sessionId}
        region={config.region}
        displayText={config.customDisplayText}
        onAnalysisComplete={setAnalysisComplete}
        onUserCancel={handleCancel}
        onError={handleError}
        disableStartScreen={true}
        />
    );
}

export default FaceLivelinessComponent;